import { FallbackLngObjList } from 'i18next';

import { PartnerMap } from '../partner/types';

import { AnalyticSegmentConfig } from 'Utilities/analytics/types';

export const CONFIG_UPDATE = 'CONFIG_UPDATE';

export interface QuickShareCodeConfig {
  lifetimeMinutes: number;
  separator: string;
  chunks: Array<QuickShareCodeChunk>;
  chunkDefaults: QuickShareCodeChunkDefaults;
}

export interface QuickShareCodeChunk {
  length: number;
  characters?: string;
  prompt?: string;
  regexInput?: string;
  regexStorage?: string;
}

interface QuickShareCodeChunkDefaults {
  characters?: string;
  prompt?: string;
  regexInput?: string;
  regexStorage?: string;
}
export interface ConfigState {
  analytics?: AnalyticSegmentConfig;
  features: {
    [feature: string]: boolean;
  };
  langFallBack: FallbackLngObjList;
  langWhiteList: string[];
  lluHome: string;
  lslApi: string;
  lv: string;
  partners: {
    api: PartnerMap;
    commercialapi: PartnerMap;
    fhir: PartnerMap;
    inbound: PartnerMap;
    insulet: PartnerMap;
    redox: PartnerMap;
  };
  privacyPolicy: {
    default: string;
    [lang: string]: string;
  };
  quickShareCode: QuickShareCodeConfig | null;
  regionalMap: {
    [region: string]: { lslApi: string };
  };
  regions: {
    [region: string]: { countries: string[] };
  };
  supportedProducts: {
    librelinkup: {
      [country: string]: boolean;
    };
    libreview: {
      [country: string]: boolean;
    };
  };
  termsOfUse?: {
    default: string;
    [language: string]: string;
  };
}

interface UpdateConfigAction {
  type: typeof CONFIG_UPDATE;
  config: ConfigState;
  country: string;
}

export type ConfigActions = UpdateConfigAction;
